import { IMoleculeInformationPanel } from '@belong/types/contentful';
import { Entry } from 'contentful';
import { FLink, FSystemIcon, IEntryLink } from '../elements';

export interface IEntryMoleculeInformationPanel {
  key?: string;
  heading: string;
  description?: string;
  link?: Entry<IEntryLink>;
  icon?: Entry<any>;
  colour: IMoleculeInformationPanel['colour'];
}
export const FMoleculeInformationPanel = (data: Entry<IEntryMoleculeInformationPanel>): IMoleculeInformationPanel => {
  const { key, heading, link, description, icon, colour } = data.fields;
  return {
    key,
    heading,
    description,
    link: link && FLink(link),
    icon: icon && FSystemIcon(icon),
    colour
  };
};
